import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { BrandService } from './brands.service';
import { ProjectsService } from 'app/_services/projects.service';

const moment = require('moment');
@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {
  dataReport: any = []
  oldFanPage = "";
  email_news_point = "";
  email_negative_alert = "";
  currentConfigItem = {
    projects: [],
    name: '',
    fanpage: "",
    fanpageId: "",
    fanpageName: "",
    main_brand: false,
    image: "",
    status: true,
    alert: false,
    news_point_alert :false,
    news_point_receiver : [],
    negative_alert :  false,
    negative_alert_receiver :[]
  }
  dtOptions: DataTables.Settings = {};
  keywords = '';
  imageSrc: any;
  file: null;
  result: any;
  source_keywords = '';
  listBrands = [];
  dataTableShow = false;
  showReport = false;
  modalRef: BsModalRef;
  isEdit = false;
  public daterange: any = {
    start: moment().startOf('day'),
    end: moment().endOf('day')
  };
  options = {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  headerReport = [];
  projects = [];
  discussProject = [];

  selectedProjects = [];
  selectedDiscussProjects = [];
  configAngularMultiSelect = {
    singleSelection: false,
    text: 'Chọn',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 5
  };
  constructor(
    private modalService: BsModalService,
    private toastrService: ToastrService,
    private brandService: BrandService,
    private projectsService: ProjectsService,
  ) {
    this.getProject();
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [1, 2, 3, 4, 5, 6], 'searchable': true }
      ]
    };
    this.getDataFromServer();
  };

  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }


  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });
  }
  addEmail(type , email) {
    if(this.validateEmail(email)) {
      if(type == 'negative_alert' && email) {
        this.currentConfigItem.negative_alert_receiver.push(email);
        this.email_negative_alert = '';
      }
      if(type == 'news_point' && email) {
        this.currentConfigItem.news_point_receiver.push(email);
        this.email_news_point = '';
      }
    } else {
      this.toastrService.warning("Vui lòng nhập đúng định dạng email !", "Thông báo")
    }

  }
   validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
  getDataFromServer() {
    this.dataTableShow = false;
    this.brandService.getAll().subscribe(res => {
      if (res.success) {
        this.dataTableShow = true;
        this.listBrands = res.data;
        this.headerReport = [];
        this.listBrands.forEach(brand => {
          this.headerReport.push(brand.name)
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }

  clickEditItem(item, modalRef) {
    this.isEdit = true;
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.currentConfigItem.projects = [];
    this.selectedProjects = [];
    this.oldFanPage = item.fanpage;
    if (item.image) {
      this.imageSrc = 'data:image/jpeg;base64,' + item.image;
    }
    item.projects.forEach(project => {
      this.selectedProjects.push({
        id: project.projectId,
        itemName: project.projectName,
        value: project.projectName
      })
    });
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }

  clickAddItem(modalRef) {
    this.isEdit = false;
    this.selectedProjects = [];
    this.currentConfigItem = {
      name: '',
      main_brand: false,
      projects: [],
      fanpage: "",
      fanpageId: "",
      fanpageName: "",
      image: "",
      status: true,
      alert : false,
      news_point_alert :false,
      news_point_receiver : [],

      negative_alert :  false,
      negative_alert_receiver :[]
    }
    this.imageSrc = "";
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }

  deleteBrand() {
    this.brandService.delete(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getDataFromServer();
        this.toastrService.success('Xóa thương hiệu thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa thương hiệu thất bại !', 'Thông báo');
      }
    });
  }

  updateBrand() {
    const validate = this.validateNewsAnalyticItem();
    if (validate) {
      //lay thong tin fanpage
      const urlPage = decodeURIComponent(this.currentConfigItem.fanpage);
      if (this.oldFanPage !== this.currentConfigItem.fanpage) {
        this.brandService.getInfoFBPriority({
          type: "page",
          urlOrId: urlPage,
          follow: true,
          isBusinessCenter: true,
          tokenPage: ""
        }).subscribe(response => {
          if (response.success) {
            this.currentConfigItem["fanpageId"] = response.data.pageId;
            this.currentConfigItem["fanpageName"] = response.data.name;
            this.selectedProjects.forEach(project => {
              this.currentConfigItem.projects.push({
                projectName: project.itemName,
                projectId: project.id
              });
            })
            this.brandService.update(this.currentConfigItem).subscribe(res => {
              if (res.success) {
                this.getDataFromServer();
                this.toastrService.success('Sửa thương hiệu thành công !', 'Thông báo');
                this.closeModal();
              }
            });
          } else {
            this.toastrService.error('Có lỗi xảy ra, không lấy được thông tin Fanpage!', 'Thông báo');
          }
        });
      } else {

          this.selectedProjects.forEach(project => {
            this.currentConfigItem.projects.push({
              projectName: project.itemName,
              projectId: project.id
            });
          })
          this.brandService.update(this.currentConfigItem).subscribe(res => {
            if (res.success) {
              this.getDataFromServer();
              this.toastrService.success('Sửa thương hiệu thành công !', 'Thông báo');
              this.closeModal();
            }
          });

      }
    }
  }
  approveBrand(item) {
    if (!item.main_brand) {
      item.status = !item.status;
      this.brandService.update(item).subscribe(res => {
        if (res.success) {
          this.getDataFromServer();
          this.toastrService.success(item.status ? "Mở khóa thương hiệu thành công" : "Khóa thương hiệu thành công", 'Thông báo');
        }
      });
    } else {
      this.toastrService.warning('Không thể khóa thương hiệu chính!', 'Thông báo');
    }

  }

  validateNewsAnalyticItem() {

    if (!this.currentConfigItem.name.trim()) {
      this.toastrService.warning('Bạn chưa nhập tên thương hiệu', 'Thông báo');
      return false;
    }
    if (this.selectedProjects.length <= 0) {
      this.toastrService.warning('Bạn chưa chọn chủ đề', 'Thông báo');
      return false;
    }
    // if (!this.currentConfigItem.fanpage.trim()) {
    //   this.toastrService.warning('Bạn chưa nhập fanpage cho thương hiệu', 'Thông báo');
    //   return false;
    // }
    if (!this.currentConfigItem.image.trim()) {
      this.toastrService.warning('Bạn chưa chọn ảnh thương hiệu', 'Thông báo');
      return false;
    }
    if(this.currentConfigItem.news_point_alert && this.currentConfigItem.news_point_receiver.length <= 0) {
      this.toastrService.warning('Bạn chưa nhập địa chỉ email nhận điểm tin thương hiệu', 'Thông báo');
      return false;
    }

    if(this.currentConfigItem.negative_alert && this.currentConfigItem.negative_alert_receiver.length <= 0) {
      this.toastrService.warning('Bạn chưa nhập địa chỉ email nhận cảnh báo tiêu cực', 'Thông báo');
      return false;
    }
    return true;
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];
    var Extension = file.name.substring(
      file.name.lastIndexOf('.') + 1).toLowerCase();

    if (Extension == "gif" || Extension == "png" || Extension == "bmp"
      || Extension == "jpeg" || Extension == "jpg") {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    } else {
      this.toastrService.warning("File không đúng định dạng!", "Thông báo");
    }

  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.currentConfigItem.image = btoa(binaryString);
    this.imageSrc = 'data:image/jpeg;base64,' + this.currentConfigItem.image;
  }

  createBrand() {
    const validate = this.validateNewsAnalyticItem();
    if (validate) {

      this.selectedProjects.forEach(project => {
        this.currentConfigItem.projects.push({
          projectName: project.itemName,
          projectId: project.id
        });
      });

      //lay thong tin fanpage
      if(this.currentConfigItem.fanpage) {
        const urlPage = decodeURIComponent(this.currentConfigItem.fanpage);
        this.brandService.getInfoFBPriority({
          type: "page",
          urlOrId: urlPage,
          follow: true,
          isBusinessCenter: true,
          tokenPage: ""
        }).subscribe(response => {
          if (response.success) {
            this.currentConfigItem["fanpageId"] = response.data.pageId;
            this.currentConfigItem["fanpageName"] = response.data.name;

            this.brandService.create(this.currentConfigItem).subscribe(res => {
              if (res.success) {
                this.getDataFromServer();
                this.toastrService.success('Thêm thương hiệu thành công !', 'Thông báo');
                this.closeModal();
              } else {
                this.toastrService.error(res.data.code == 11000 ? 'Tên thương hiệu bị trùng !' : res.msg, 'Thông báo');
              }
            });
          } else {
            this.toastrService.error('Có lỗi xảy ra, không lấy được thông tin Fanpage!', 'Thông báo');
          }
        });
      } else {
        this.currentConfigItem["fanpageId"] = "";
        this.currentConfigItem["fanpageName"] = "";
        this.brandService.create(this.currentConfigItem).subscribe(res => {
          if (res.success) {
            this.getDataFromServer();
            this.toastrService.success('Thêm thương hiệu thành công !', 'Thông báo');
            this.closeModal();
          } else {
            this.toastrService.error(res.data.code == 11000 ? 'Tên thương hiệu bị trùng !' : res.msg, 'Thông báo');
          }
        });
      }
    }
  }



  updateMainBrand(item) {
    this.brandService.updateMainBrand(item).subscribe(res => {
      if (res.success) {
        this.getDataFromServer();
        this.toastrService.success('Cập nhật thương hiệu thành công !', 'Thông báo');
      }
    });
  }

  closeModal() {
    this.modalRef.hide();
  }

  handlerKeyword(keyword) {
    var listKeywords = keyword.split('|');
    for (var i in listKeywords) {
      listKeywords[i] = listKeywords[i].trim();
      if (listKeywords[i] == '') {
        delete listKeywords[i];
      }
    }
    return listKeywords;
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/brand-manage/brands.component.ts